export default __webpack_public_path__ + "static/media/nagarjun.555080ac.jpg";